const currencyPrefix = {
  BRL: 'R$ ',
  PEN: 'S/ ',
} as const;

export { currencyPrefix };
